class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.getElementById('shopify-section-global--header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      window.addEventListener('DOMContentLoaded', (event) => { observer.observe(this.header)});;
      observer.observe(this.header)
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop ) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop ) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
    }
    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      this.header.classList.remove('shopify-section-header-sticky', 'animate');
    }
}
customElements.define('sticky-header', StickyHeader);
class MegaMenu extends HTMLElement {
	constructor() {
		super();
		this.wrapper = document.querySelector("navbar__mega-menu");
		this.trigger = document.querySelector("[data-mega-menu-trigger]");
		this.menu = document.querySelector(".component--header--mega-menu");
		this.tabs = document.querySelectorAll(".component--header--mega-menu__tab");
		this.tabPanels = document.querySelectorAll(
			".component--header--mega-menu__panel"
		);
		const headerHeight = document.querySelector(".header").clientHeight;
		document.querySelector(".component--header--mega-menu").style.top = headerHeight + 'px';
		this.bindEvents();
	}
	bindEvents() {
		this.trigger.addEventListener("mouseenter", this.hoverIn.bind(this));
		//this.trigger.addEventListener("mouseleave", this.hoverOut.bind(this));
		this.menu.addEventListener("mouseenter", this.hoverIn.bind(this));
		this.menu.addEventListener("mouseleave", this.hoverOut.bind(this));
		this.tabs.forEach((tab) =>
			tab.addEventListener("click", this.select.bind(this))
		);
	}
	hoverIn() {
		this.menu.classList.add("component--header--mega-menu--active");
		this.trigger.classList.add("navbar__item--active");
	}
	hoverOut() {
		this.menu.classList.remove("component--header--mega-menu--active");
		this.trigger.classList.remove("navbar__item--active");
	}
	select(event) {
		const selectedTab = event.currentTarget;
		this.tabs.forEach((tab, index) => {
			if (this.tabPanels[index] != undefined) {
				if (tab === selectedTab) {
					tab.classList.add("component--header--mega-menu__tab--active");
					this.tabPanels[index].classList.add(
						"component--header--mega-menu__panel--active"
					);
				} else {
					tab.classList.remove("component--header--mega-menu__tab--active");
					this.tabPanels[index].classList.remove(
						"component--header--mega-menu__panel--active"
					);
				}
			}
		});
	}
}
customElements.define("mega-menu", MegaMenu);
